import { Contact } from '@features/contacts/types/contact'
import { getCompanyName } from '@modules-deprecated/app/companies/utils/getCompanyName'
import { Organization } from '@modules-deprecated/app/organization/types/organization'

import { convertBookkeepingTagNavItemValueToDbValue } from '../../../selects/BookkeepingHeroSelect/utils/convertBookkeepingTagNavItemValueToDbValue'
import { ContactForm } from './formData'
import { isPersonContactType } from './isPersonContactType'

export const getCreateSupplierPayload = (contactForm: ContactForm, organization?: Organization): Partial<Contact> => {
  const {
    defaultBookkeepingTag,
    companyFromSearch,
    companyName,
    contactType,
    country,
    defaultExpenseAccount,
    defaultProductDescription,
    email,
    paymentTermsMode,
    personFirstName,
    personLastName,
    taxId,
  } = contactForm

  const basePayload: Partial<Contact> = {
    type: contactType,
    isSupplier: true,
    organizationId: organization?.id,
    defaultTaxRateId: paymentTermsMode?.id,
    defaultExpenseAccountId: defaultExpenseAccount?.id,
    defaultExpenseProductDescription: defaultProductDescription,
    defaultBookkeepingTag:
      defaultBookkeepingTag?.tag && defaultBookkeepingTag?.response
        ? JSON.stringify(convertBookkeepingTagNavItemValueToDbValue(defaultBookkeepingTag))
        : null,
  }

  if (isPersonContactType(contactType)) {
    const contactName = `${personFirstName || ''} ${personLastName || ''}`.trim()

    return {
      ...basePayload,
      countryId: country?.id,
      name: contactName,
      contactPersons: [
        {
          firstName: personFirstName,
          lastName: personLastName,
          email,
        },
      ],
    }
  }

  const companyFromSearchName = getCompanyName(companyFromSearch)
  const isCompanyFromSearch = !!companyFromSearchName
  const name = isCompanyFromSearch ? companyFromSearchName : companyName
  const registrationNo = isCompanyFromSearch ? companyFromSearch?.id : taxId
  // Currently search is always performed based on the organization country
  const countryId = isCompanyFromSearch ? organization?.countryId : country?.id

  return {
    ...basePayload,
    registrationNo,
    countryId,
    name,
    cityText: companyFromSearch?.city,
    street: companyFromSearch?.street,
    zipcodeText: companyFromSearch?.zipcode,
    stateText: companyFromSearch?.state,
    phone: companyFromSearch?.phone || undefined,
    vatNo: companyFromSearch?.vatNo || registrationNo,
  }
}
